import { Call } from "@twilio/voice-sdk";
export default class TwilioCall {
  constructor(
    public call: Call,
    public callSid: string,
    public from: string,
    public to: string
  ) {}
}